<template>
	<div class="content">
		<div class="bg-grey-12 rounded-xl text-white p-6 mb-6">
			<div class="flex gap-6">
				<!-- Trading Chart -->
				<div class="grow">
					<TradingChart chart_width="100%" chart_height="480" defaultSymbolAnchor_prop="FX_IDC-XAUIDRG"
						defaultSymbol_prop="FX_IDC:XAUIDRG" :showTitle_prop="false"></TradingChart>
				</div>

				<!-- Contract (Only for Gopay account) -->
				<div v-if="$store.getters.paymentMethod == 'gopay'" class="w-min min-w-75">
					<div class="text-1.5xl font-bold mb-3">Contract</div>

					<div class="text-sm text-grey mb-6">
						The JFXGOLDX account, using E-Wallet as the payment method, applies a 0.01 g pool contract.
					</div>

					<div class="mb-3">
						<!-- <TradeBox :contractId_prop="Number($store.state.contractIds.contract_001g)" :clickAble="false"> </TradeBox> -->
						<TradeBoxV2 :contractId_prop="Number($store.state.contractIds.contract_001g)"
							@clickButton="(directionVal) => updateTradeTicket($store.state.contractIds.contract_001g, directionVal)" />
					</div>
				</div>

			</div>
		</div>

		<div v-if="$store.getters.paymentMethod == 'rped'" class="flex gap-4 flex-wrap mb-10">
			<div class="grow bg-grey-12 p-6 rounded-2.5xl">
				<div class="text-white text-xl font-bold mb-6">Pool Contract</div>

				<div :class="`${animatedBackgroundClass} items-tradebox flex justify-center gap-3 flex-wrap mb-6`">
					<div v-for="(item, index) in tradeBoxPool" v-bind:key="item.id" class="ga-tradebox box flex-1 max-w-75">
						<TradeBoxV2 :showGoldDrip="true" @click.native="updateTradeTicket(item.id)"
							:contractId_prop="Number(item.id)" />
					</div>
				</div>
				<div class="text-grey text-xs">
					Gold is stored together in a single bar, with ownership based on the grams you own
				</div>
			</div>

			<div class="grow bg-grey-12 p-6 rounded-2.5xl">
				<div class="text-white text-xl font-bold mb-6">Non Pool Contract</div>
				
				<div :class="`${animatedBackgroundClass} items-tradebox flex justify-center gap-3 flex-wrap mb-6`">
					<div v-for="(item, index) in tradeBoxNonPool" v-bind:key="item.id" class="ga-tradebox box flex-1 max-w-75">
						<TradeBoxV2 :showGoldDrip="true" @click.native="updateTradeTicket(item.id)"
							:contractId_prop="Number(item.id)" />
					</div>
				</div>
				<div class="text-grey text-xs">
					Gold is stored separately, with ownership recorded individually
				</div>
			</div>
		</div>

		<div v-if="false" class="row">
			<div class="col-12">
				<div class="card bg-grey-1 rounded-xl">
					<div class="card-header">
						<h3 class="title d-inline">Contracts</h3>
					</div>
					<div class="card-body">
						<div :class="animatedBackgroundClass">
							<div v-if="setTradeBoxStatus == 'loading' && $store.state.setHoldingsApiStatus != 'success'"
								class="loader-chart">
								<Loader size_prop="5em" borderSize_prop="0.4em"></Loader>
							</div>
							<div v-else-if="tradeBox" class="row justify text-center">
								<div v-for="(item, index) in tradeBox" v-bind:key="index" class="col mb-4">
									<TradeBox :showGoldDrip="true" @click.native="updateTradeTicket(item.id)" data-toggle="modal"
										data-target="#exampleModal" :contractId_prop="Number(item.id)"> </TradeBox>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="flex flex--same-width gap-7 flex-wrap">
			<div class="">
				<div class="bg-grey-1 rounded-xl p-4 mb-6">
					<div class="text-white text-xl font-bold mb-6">Bloomberg TV</div>

					<div class="text-center mb-6">
						<video width="100%" height="" controls>
							<source src="https://www.bloomberg.com/media-manifest/streams/phoenix-us.m3u8" type="video/mp4">
							Your browser does not support the video tag.
						</video>
					</div>

					<div class="text-grey text-sm">
						Track global gold price movements in real-time. Latest market data from Bloomberg Markets.
					</div>
				</div>

				<div class="card card-tasks bg-grey-1 rounded-xl" style="height: 689px">
					<div class="card-header">
						<h3 class="title d-inline">News <span style="color: gold">Gold</span></h3>
					</div>
					<div class="card-body">
						<div class="table-full-width table-responsive" style="height: 580px; max-height: 1000px" id="scrollbar1">
							<table class="table">
								<tbody>
									<tr v-for="item in news" :key="item.title">
										<td>
											<p class="title news-title">
												<a :href="item.url" target="_blank">{{ item.title }}</a>
											</p>
											<p class="text-muted">{{ item.description }}</p>
											<p class="text-muted">{{ item.pubDate }}</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>

			<div class="">
				<ExchangeRate class="mb-5"></ExchangeRate>

				<div class="card bg-grey-1 rounded-xl">
					<div class="card-header">
						<h3 class="card-title">Economic Calendar</h3>
					</div>
					<div v-if="environment != 'development'" class="card-body">
						<EconomicCalendar width="100%" height="600"></EconomicCalendar>
					</div>
				</div>
			</div>
		</div>

		<GoldDripLanding />

		<TradeTicket ref="tradeTicketRef" :contractId_prop="tradeTicket.contractId"
			:product_is_active_prop="tradeTicket.productIsActive" :ticker_prop="tradeTicket.ticker" :name="tradeTicket.name"
			:weight="tradeTicket.weight" :weightCorection_prop="tradeTicket.weightCorrection"
			:openSellOrders_prop="openSellOrders" :directionDefault_prop="tradeTicket.direction">
		</TradeTicket>
	</div>
</template>

<script>
/*eslint-env jquery*/
import axios from '@/api/axios.js'
import { Decimal } from 'decimal.js'

import PerfectScrollbar from 'perfect-scrollbar'
import TradeBox from '@/components/TradeBox.vue'
import TradeTicket from '@/components/TradeTicket.vue'
import TradingChart from '@/components/TradingChart.vue'
import EconomicCalendar from '@/components/EconomicCalendar.vue'
import ExchangeRate from '../components/ExchangeRate.vue'
import Loader from '@/components/Loader.vue'
import { bus } from '../main'
import GoldDripLanding from '../components/GoldDripLanding.vue'
import TradeBoxV2 from '../components/TradeBoxV2.vue'

import utils from '../utils'


export default {
	name: 'Dashboard',
	components: {
		TradeBox,
		TradeTicket,
		TradingChart,
		EconomicCalendar,
		ExchangeRate,
		Loader,
		GoldDripLanding,
		TradeBoxV2
	},
	data() {
		return {
			environment: process.env.NODE_ENV,
			publicPath: process.env.BASE_URL,
			tradeTicket: {
				goldId: '',
				productId: '',
				name: '',
				weight: 0,
				buyPrice: 0,
				sellPrice: 0,
				contractId: '',
			},

			srcStream1: '',
			srcStream2: '',

			tradeBox: [],
			tradeBoxPool: [],
			tradeBoxNonPool: [],
			streamPlayButtonDisplay: 'block',
			streamNone: '',

			news: [],

			animatedBackgroundClass: 'animated-background',

			setTradeBoxStatus: 'loading',

			openSellOrders: {},
		}
	},
	computed: {
		accountLevel() {
			return this.$store.getters.getAccountLevel
		},

		contracts() {
			let contract = this.$store.state.contracts
			return contract
		},
		products() {
			let products = this.$store.getters.PRODUCTS
			return products
		},
		golds() {
			let golds = this.$store.state.golds
			return golds
		},
		currency() {
			let currency = this.$store.state.currency
			return currency
		},

		srcVideo() {
			let video = this.$store.state.srcVideo
			// console.log(video)
			return video
		},

		gold() {
			return this.$store.getters.getGoldByContractId(this.$store.state.contractIds.contract_001g)
		},

		contractConfigs() {
			return this.$store.getters.getContractConfigs(this.$store.state.contractIds.contract_001g)
		},

		streamingRate() {
			return this.$store.getters.getStreamingRate
		},

		sellShown() {
			if (!this.gold) {
				return '-'
			}

			let sellPrice = new Decimal(this.gold.sell)

			if (this.currency == "idr") {
				sellPrice = sellPrice.times(this.streamingRate.streamSell)
			}

			return utils.currencyFormat(sellPrice.toDecimalPlaces(this.contractConfigs.tbTtDecimalPlace).toFixed())
		},
		buyShown() {
			if (!this.gold) {
				return '-'
			}

			let buyPrice = new Decimal(this.gold.buy)

			if (this.currency == "idr") {
				buyPrice = buyPrice.times(this.streamingRate.streamBuy)
			}

			return utils.currencyFormat(buyPrice.toDecimalPlaces(this.contractConfigs.tbTtDecimalPlace).toFixed())
		},
	},
	watch: {
		// contracts() {
		// 	this.setTradeBoxBefore()
		// },
		// golds() {
		// 	this.setTradeBoxBefore()
		// },
		// products() {
		// 	this.setTradeBoxBefore()
		// },
		// currency() {
		// 	this.setTradeBoxBefore()
		// },
	},
	created() {
		const firstCall = setInterval(() => {
			if (this.contracts && this.products && this.golds) {
				clearInterval(firstCall)

				this.setTradeBoxBefore()
				let rssUrls = {
					name: 'Commodities & Futures News',
					url: 'https://www.investing.com/rss/news_11.rss',
				}
				// Feed.load(`${process.env.VUE_APP_PROXY}/${rssUrls.url}`, (err, rss) => {
				//   this.news = rss.items
				// })

				fetch(`${process.env.VUE_APP_PROXY}/${rssUrls.url}`)
					.then((response) => response.text())
					.then((str) => new window.DOMParser().parseFromString(str, 'text/xml'))
					.then((data) => {
						const items = data.querySelectorAll('item')
						items.forEach((el) => {
							this.news.push({
								title: el.querySelector('title').innerHTML,
								url: el.querySelector('link').innerHTML,
								description: el.querySelector('title').innerHTML,
								pubDate: el.querySelector('pubDate').innerHTML,
							})
						})
					})

				// const bus = new Vue()
				bus.$on('reload', () => {
					this.streamNone = 1
					this.$refs.video.load()
					let playPromise = this.$refs.video.play()
					if (playPromise !== undefined) {
						playPromise
							.then((response) => {
								// Automatic playback started!
								// Show playing UI.
								console.log('HAHAHAHAH', response)
							})
							.catch((error) => {
								// Auto-play was prevented
								// Show paused UI.
								console.log('HIHIHIHIHI', error)
							})
					}
				})
			}
		}, 1000)

		this.$store.dispatch('setHoldings')
		this.setOpenSellOrders()

		// fetch goldBalance
		this.$store.dispatch('goldBalanceNew/fetchGoldBalance', {
			user_id: this.$store.state.userId
		})
	},

	mounted() {
		// this.$refs.tradeTicketRef.openTradeTicket()

		const ps1 = new PerfectScrollbar('#scrollbar1', {
			wheelPropagation: false,
		})
		ps1.update()

		this.$nextTick(this.syncBoxes)
		window.addEventListener("resize", this.syncBoxes)

		// const ps2 = new PerfectScrollbar('.slider')
		// ps2.update()
	},
	methods: {
		syncBoxes() {
			const rows = this.$el.querySelectorAll(".items")

			let max = 0

			rows.forEach(row => {
				max = Math.max(max, row.children.length)
			})

			const width = 100 / max

			this.$el.querySelectorAll(".box").forEach(box => {
				box.style.flex = `0 0 ${width}%`
			})
		},
		// changeVideo(urlVideo) {
		//   fetch(urlVideo)
		//   .then(response => response.blob())
		//   .then(blob => {
		//     this.$refs.video.srcObject = blob;
		//     console.log('HEHEHEHE', blob)
		//     return this.$refs.video.play();
		//   })
		//   .then(response2 => {
		//     // Video playback started ;)
		//     console.log('HAHAHAHA', response2)
		//   })
		//   .catch(error => {
		//     // Video playback failed ;(
		//     console.log('HIHIHIHIHI', error, urlVideo)
		//   })
		// },
		setTradeBoxBefore() {
			this.setTradeBoxStatus = 'loading'

			this.tradeBox = []
			const contracts = this.contracts
			const streamingRate = this.$store.getters.getStreamingRate
			const golds = this.golds

			let arr = []

			if (golds && contracts) {
				for (let i = 0; i < contracts.length; i++) {
					if (contracts[i].attributes.contractStatusId != 'active') {
						continue
					}

					arr.push({
						id: contracts[i].id,
					})
				}

				this.setTradeBoxAfter(arr)
			}
		},
		setTradeBoxAfter(arr) {
			const contractIds = this.$store.state.contractIds
			const tradeBoxOrder = [contractIds.contract_000001g, contractIds.contract_001g, contractIds.contract_1g, contractIds.contract_100g, contractIds.contract_1kg]

			let tradeBoxTemp = []
			let tradeBoxPoolTemp = []
			let tradeBoxNonPoolTemp = []
			for (let j = 0; j < tradeBoxOrder.length; j++) {
				const contract = arr.find((obj) => obj.id == tradeBoxOrder[j])

				tradeBoxTemp.push(contract)

				const contractConfig = this.$store.getters.getContractConfigs(tradeBoxOrder[j])
				if (contractConfig.isPool) {
					tradeBoxPoolTemp.push(contract)
				} else {
					tradeBoxNonPoolTemp.push(contract)
				}
			}

			this.tradeBox = tradeBoxTemp
			this.tradeBoxPool = tradeBoxPoolTemp
			this.tradeBoxNonPool = tradeBoxNonPoolTemp

			this.setTradeBoxStatus = 'idle'
			this.animatedBackgroundClass = 'animated-background-finish'
		},
		updateTradeTicket(contractId, directionDefault = 'buy') {
			const contract = this.contracts.find((obj) => obj.id == contractId)
			const contractConfig = this.$store.getters.getContractConfigs(contractId)

			let tradeTicketTemp = {}

			tradeTicketTemp.name = contractConfig.tradeTicketName
			tradeTicketTemp.weight = contractConfig.weightInGram
			tradeTicketTemp.ticker = contract.attributes.ticker
			tradeTicketTemp.direction = directionDefault

			if (!contract) {
				tradeTicketTemp.contractId = '0'
				tradeTicketTemp.productIsActive = false
				tradeTicketTemp.weight = 0
			} else {
				tradeTicketTemp.ticker = contract.attributes.ticker
				tradeTicketTemp.productIsActive = contract.attributes.contractStatusId
				tradeTicketTemp.weightCorrection = contractConfig.weightCorrection
				tradeTicketTemp.contractId = contract.id
			}

			this.tradeTicket = tradeTicketTemp
			this.$refs.tradeTicketRef.openTradeTicket()
		},

		setOpenSellOrders() {
			const listContract = this.$store.state.contractIds
			let contractParam = ''
			for (let key in listContract) {
				contractParam += 'contractId[]=' + listContract[key] + '&'
			}

			axios
				.post('/v2/igx/orders?order_type=limit&' + contractParam + 'status=submit', {
					user_id: this.$store.state.userId,
				})
				.then((response) => {
					if (!response.data.data.body) {
						return
					}

					const orders = response.data.data.body.filter((obj) => obj.attributes.direction == 'sell')

					const uniqueContract = [...new Set(orders.map((obj) => obj.attributes.contractId))]

					let temp = {}
					for (let i = 0; i < uniqueContract.length; i++) {
						const orderWithId = orders.filter((obj) => obj.attributes.contractId == uniqueContract[i])

						let quantityTemp = 0
						orderWithId.forEach((order) => {
							quantityTemp += Decimal.div(order.attributes.quantity, this.$store.getters.getContractConfigs(uniqueContract[i]).weightCorrection).toNumber()
						})

						this.$set(temp, uniqueContract[i], quantityTemp)
					}

					// const temp = {
					//   [this.$store.state.contractIds.contract_100g]: orders.filter(obj => obj.attributes.contractId == this.$store.state.contractIds.contract_100g),
					//   [this.$store.state.contractIds.contract_1kg]: orders.filter(obj => obj.attributes.contractId == this.$store.state.contractIds.contract_1kg),
					//   [this.$store.state.contractIds.contract_1g]: orders.filter(obj => obj.attributes.contractId == this.$store.state.contractIds.contract_1g),
					//   [this.$store.state.contractIds.contract_001g]: orders.filter(obj => obj.attributes.contractId == this.$store.state.contractIds.contract_001g)
					// }

					this.openSellOrders = temp
				})
				.catch((error) => {
				})
		},

		playStream() {
			this.streamPlayButtonDisplay = 'none'
			this.srcStream1 = 'https://livenewschat.eu/stocks/'
			this.srcStream2 = ''
		},
		changeStream(value) {
			this.streamPlayButtonDisplay = 'none'
			if (value == 'stream1') {
				this.srcStream1 = 'https://livenewschat.eu/stocks/'
				this.srcStream2 = ''
			} else {
				this.srcStream1 = ''
				this.srcStream2 = 'https://livenewschat.eu/business/'
			}
		},
		refreshStream() {
			if (this.srcStream1 !== '') {
				document.getElementById('videoFrame1').src = document.getElementById('videoFrame1').src
			} else {
				document.getElementById('videoFrame2').src = document.getElementById('videoFrame2').src
			}
		},
		goTo(url) {
			window.open(url, '_blank')
			// window.location.assign(url)
		},
	},
}
</script>

<style scoped>
.main-video {
	margin-top: 49px;
	width: 100%;
}

.c-trade-box {}

.stream-play-button {
	margin-top: 100px;
}

.stream-play-button:hover {
	cursor: pointer;
}

/*#frameContainer {
    pointer-events: ;
  }*/

.slider {
	/*background-color: black;*/
	height: 300px;
	display: flex;
	overflow-x: auto;
}

.slider-item {}

.news-title a {
	color: rgba(255, 255, 255, 0.8);
}

.news-title:hover {
	cursor: pointer;
	text-decoration: underline;
}

.c-nav-tabs > li {
	float: none;
	text-align: center;
	display: inline-block;
}

.loader-chart {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

@keyframes placeHolderShimmer {
	0% {
		background-position: -800px 0;
	}

	100% {
		background-position: 800px 0;
	}
}

.animated-background-finish {
	background-color: transparent;
	min-height: 189px;
	/*margin-bottom: 25px;*/
}

.animated-background {
	min-height: 189px;
	margin-bottom: 25px;
	border-radius: 0.26rem;

	animation-duration: 2s;
	animation-fill-mode: forwards;
	animation-iteration-count: infinite;
	animation-name: placeHolderShimmer;
	animation-timing-function: linear;
	background-color: #f6f7f8;
	background: linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%);
	background-size: 800px 104px;
	height: 70px;
	position: relative;
}

.css-dom:empty {
	width: 280px;
	height: 220px;
	border-radius: 6px;
	box-shadow: 0 10px 45px rgba(0, 0, 0, 0.2);
	background-repeat: no-repeat;

	background-image: radial-gradient(circle 16px, lightgray 99%, transparent 0), linear-gradient(lightgray, lightgray), linear-gradient(lightgray, lightgray), linear-gradient(lightgray, lightgray), linear-gradient(lightgray, lightgray), linear-gradient(#fff, #fff);

	background-size: 32px 32px, 200px 32px, 180px 32px, 230px 16px, 100% 40px, 280px 100%;

	background-position: 24px 30px, 66px 30px, 24px 90px, 24px 142px, 0 180px, 0 0;
}
</style>
